<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="库存分析" />
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">期初总库存</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.totalqcitem_num }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">期初货值</div>
                <div class="yesterday summaryLine">
                  <p>¥{{ summarizeData.totalqcitem_money | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">期末总库存</div>
                <div class="summaryLine">
                  <p>{{ summarizeData.totalqmitem_num }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">期末货值</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totalqmitem_money | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">资金周转率</div>
                <div class="summaryLine">
                  <p>{{ summarizeData.totalturnover_rate }}%</p>
                </div>
              </div>
              <!-- <div class="subtotals">
                <p>销售总金额：{{ summarizeData.num }} 瓶</p>
                <p>期初货值：¥{{ summarizeData.num | money }}</p>
              </div> -->
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
    </basicList>
  </div>
</template>


<script>
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getinventorylist } from "@/api/report";
import { itemClassGetList, getshoplist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "inventoryAnalysis",
  data() {
    return {
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
            value: [],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "item_number",
            sortable: true,
            width: 150,
          },
          {
            label: "品名",
            prop: "item_name",
            width: 250,
            fixed: "left",
          },
          {
            label: "分类",
            prop: "class_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 180,
          },
          {
            label: "周转率",
            prop: "turnover_rate",
            sortable: true,
            width: 200,
          },
          {
            label: "期初库存",
            prop: "qcitem_num",
            sortable: true,
            width: 200,
          },
          {
            label: "期末库存",
            prop: "qmitem_num",
            sortable: true,
            width: 200,
          },
          {
            label: "采购数量",
            prop: "buy_num",
            sortable: true,
            width: 200,
          },
          {
            label: "销售数量",
            prop: "sell_num",
            sortable: true,
            width: 200,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      // 统计数据
      summarizeData: {
        totalqcitem_money: 0,
        totalqcitem_num: 0,
        totalqmitem_money: 0,
        totalqmitem_num: 0,
        totalturnover_rate: 0,
        num: 0,
      },
    };
  },
  created() {
    this.obtainDataSource();
    this.basicListconfig.search.map((item) => {
      if (item.key == "time") {
        item.value = [this.$getCurrent(2), this.$getCurrent(2)];
      }
      return item;
    });
    this.searchEvent({
      time: [this.$getCurrent(2), this.$getCurrent(2)],
      shop_id: JSON.parse(getRoles()).shop_id,
    });
  },
  methods: {
    // 排序方法
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getData();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    getData() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "time") {
          item.value = [
            this.basicListconfig.searchParameters["begin_time"],
            this.basicListconfig.searchParameters["end_time"],
          ];
        }
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      console.log(this.basicListconfig.searchParameters);
      getinventorylist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list.map((item) => {
            item.turnover_rate =
              item.turnover_rate && item.turnover_rate != 0
                ? item.turnover_rate + "%"
                : "--";
            return item;
          });
          for (const key in this.summarizeData) {
            this.summarizeData[key] = res[key];
          }
        } else {
          this.basicListconfig.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/inventoryAnalysis/index.vue